import {dataMember, required, typedArray} from 'santee-dcts';
import {KeyValuePair} from '../../../documents/document-filter-item';

export class EQueryAdminSummaryFilterItem {
    @required({ nullable: true })
    @dataMember()
    public protocol : KeyValuePair;

    @required({ nullable: true })
    @dataMember()
    public accessionNumber : KeyValuePair;
}

export class EQueryAdminSummaryFilterItemsReadModel {
    @dataMember()
    @required()
    @typedArray(EQueryAdminSummaryFilterItem)
    public filterItems: EQueryAdminSummaryFilterItem[];
}
